import { render } from "./QuestionnaireDialog.vue?vue&type=template&id=31a96b4c"
import script from "./QuestionnaireDialog.vue?vue&type=script&lang=ts"
export * from "./QuestionnaireDialog.vue?vue&type=script&lang=ts"

import "./QuestionnaireDialog.vue?vue&type=style&index=0&id=31a96b4c&lang=scss"
script.render = render

export default script